<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>category</md-icon>
                    </div>
                    <h4 class="title">Assign Permission to Role</h4>
                </md-card-header>

                <form @submit.prevent="add">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Role
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <multiselect v-model="item.role.id"
                                                 deselect-label="Can't remove this Role"
                                                 track-by="id"
                                                 id="index"
                                                 label="name"
                                                 placeholder="Select Role"
                                                 :options="available_roles"
                                                 :searchable="true">
                                    </multiselect>
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Permission
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <multiselect v-model="permissions"
                                                 deselect-label="Can't remove this Role"
                                                 track-by="id"
                                                 id="permissions"
                                                 multiple="true"
                                                 label="name"
                                                 placeholder="Select Role"
                                                 :options="available_permissions"
                                                 :searchable="true">
                                    </multiselect>
                                    <md-select
                                            v-model="permissions"
                                            @md-selected="updatePermissions"
                                            name="permissions"
                                            multiple
                                    >
                                        <md-option
                                                v-for="permission in available_permissions"
                                                :key="'permission_' + permission.id"
                                                :value="permission.id"
                                        >
                                            {{ permission.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add Item</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import formMixin from '@/mixins/form-mixin';


export default {
    mixins: [formMixin],
    components:{ Multiselect },
    data () {
        return {
            item: {
                type: 'items',
                name: null,
                description: null,
                excerpt: null,
                status: 'published',
                role: {
                    id: null,
                    type: 'categories',
                },
                permissions: [],
                is_on_homepage: false,
                date_at: null,
                relationshipNames: ['roles'],
            },

            available_categories: [],
            available_permissions: [],
            available_roles: [],

            image: '',
            file: null,
            default_image: process.env.VUE_APP_BASE_URL + '/img/placeholder.jpg',

            permissions: [],
        };
    },

    created () {
        this.getCategories();
        this.getPermissions();
        this.getRoles();
        this.getPermissions();
    },

    methods: {
        async add () {
            delete this.item.id;
            this.resetApiValidation();

            this.item.excerpt = this.item.description;
            this.item.date_at = moment(this.item.date_at).format('YYYY-MM-DD');
            try {
                await this.$store.dispatch('items/add', this.item);
                this.item = await this.$store.getters['items/item'];

                if (!this.file) {
                    // upload image and get image url
                    await this.$store.dispatch('items/upload', {
                        item: this.item,
                        image: this.file,
                    });
                    this.item.image = await this.$store.getters['items/url'];
                    // update item with image url
                    await this.$store.dispatch('items/update', this.item);
                    this.user = await this.$store.getters['items/item'];
                }

                await this.$store.dispatch(
                    'alerts/success',
                    'Item added successfully.'
                );

                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                    this.setApiValidation(e.response.data.errors);
                }

                if (this.item.id) {
                    await this.$store.dispatch('items/destroy', this.item.id);
                }
            }
        },

        updatePermissions () {
            this.item.permissions = [];
            this.permissions.forEach((permission) => {
                this.item.permissions.push({
                    id: permission,
                    type: 'permissions',
                });
            });
        },
        getRoles () {
            this.$store.dispatch('roles/list').then(() => {
                this.available_roles = this.$store.getters['roles/dropdown'];
                if (this.available_roles && this.available_roles.length) {
                    this.item.role.id = this.available_roles[0].id;
                }
            });
        },

        getPermissions () {
            this.$store.dispatch('permissions/list').then(() => {
                this.available_permissions = this.$store.getters['permissions/list'];
                if (this.available_permissions && this.available_permissions.length) {
                    this.permissions.id = this.available_permissions[0].id;
                }
            });
        },


        async getAssignedPermissions (id) {
            try {
                await this.$store.dispatch('roles/permissions', id);
                this.permissionData = this.$store.getters['roles/list'];
                alert('permission data called');
                console.log(this.permissionData);
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong! Failed to load permissions for this Role'
                );
            }
        },


        getCategories () {
            this.$store.dispatch('roles/list').then(() => {
                this.available_categories = this.$store.getters['roles/dropdown'];
                // if (this.available_categories && this.available_categories.length>0) {
                //     this.item.category.id = this.available_categories[0].id;
                // }
            });
        },
        // getPermissions() {
        //     this.$store.dispatch("permissions/list").then(() => {
        //         this.available_permissions = this.$store.getters["permissions/dropdown"];
        //         if (this.available_permissions && this.available_permissions.length) {
        //             this.permissions.push(this.available_permissions[0].id);
        //             this.updatePermissions();
        //         }
        //     });
        // },

        onFileChange (e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            this.createImage(files[0]);
        },

        createImage (file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.image = e.target.result;
                this.file = file;
            };
            reader.readAsDataURL(file);
        },

        removeImage () {
            this.image = null;
        },

        goBack () {
            this.$router.push({ name: 'List Items' });
        },
    },
};
</script>

<style lang="scss" scoped>
    .spacing {
        padding-bottom: 1rem;
    }

    .md-inline-checkboxes {
        display: inline-flex;

        .md-checkbox {
            margin-top: 15px !important;
        }
    }

    .md-checkbox,
    .md-radio {
        margin-top: 15px;
        margin-bottom: 0.5rem;
    }

    .md-checkbox,
    .md-radio {
        display: flex;
    }

    .md-radio .md-radio-container {
        margin-left: 5px;
        position: relative;
        left: -3px;
    }

    .md-form-label + .md-layout-item .md-checkbox:not(:first-child),
    .md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
    .md-form-label + .md-layout-item .md-radio {
        margin-top: 0;
    }

    .md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
        padding-left: 0;
        padding-top: 10px;
        min-height: 150px;
    }

    .md-field:after,
    .md-field:before {
        bottom: 10px !important;
    }
</style>
<style>
    .ck-editor__editable {
        min-height: 200px;
        width: auto;
    }
</style>
